

import { useState } from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaBars, FaTimes } from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import { Link } from "react-scroll";
import logo from "../assests/logo.png";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Top Bar */}

      <div className="bg-green-900 text-white hidden md:flex justify-between items-center px-6 lg:px-12 py-2 text-sm">

        <p>Welcome to DV Coconut Farms</p>

        <div className="flex items-center gap-5">

          <div className="flex items-center gap-2">
            <MdPhone />
            <span>+91 9994548118</span>
          </div>

          <div className="flex items-center gap-2">
            <MdEmail />
            <span>gowthamv187@gmail.com</span>
          </div>

          <FaFacebookF className="cursor-pointer hover:text-green-300 transition" />
          <FaInstagram className="cursor-pointer hover:text-green-300 transition" />
          <FaWhatsapp className="cursor-pointer hover:text-green-300 transition" />

        </div>

      </div>

      {/* Navbar */}

      <nav className="sticky top-0 z-50 bg-white shadow-md">

        <div className="max-w-7xl mx-auto flex justify-between items-center px-5 md:px-8 lg:px-12 py-3">

          {/* Logo */}

          <Link
            to="home"
            smooth={true}
            duration={600}
            offset={-80}
            className="cursor-pointer"
          >
            <img
              src={logo}
              alt="DV Coconut"
              className="h-14 md:h-16 lg:h-18 w-auto"
            />
          </Link>

          {/* Desktop Menu */}

          <ul className="hidden lg:flex items-center gap-8 font-medium text-gray-700">

            <Link
              to="home"
              smooth={true}
              duration={600}
              offset={-80}
              className="cursor-pointer hover:text-green-700 transition"
            >
              Home
            </Link>

            <Link
              to="about"
              smooth={true}
              duration={600}
              offset={-80}
              className="cursor-pointer hover:text-green-700 transition"
            >
              About
            </Link>

            <Link
              to="products"
              smooth={true}
              duration={600}
              offset={-80}
              className="cursor-pointer hover:text-green-700 transition"
            >
              Products
            </Link>

            <Link
              to="gallery"
              smooth={true}
              duration={600}
              offset={-80}
              className="cursor-pointer hover:text-green-700 transition"
            >
              Gallery
            </Link>

            <Link
              to="contact"
              smooth={true}
              duration={600}
              offset={-80}
              className="cursor-pointer hover:text-green-700 transition"
            >
              Contact
            </Link>

          </ul>

          {/* Mobile Menu Button */}

          <button
            className="lg:hidden text-2xl text-green-700"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>

        </div>

        {/* Mobile Menu */}

        {menuOpen && (

          <div className="lg:hidden bg-white shadow-xl">

            <div className="flex flex-col text-center py-4 space-y-5 font-medium">

              <Link
                to="home"
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setMenuOpen(false)}
              >
                Home
              </Link>

              <Link
                to="about"
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setMenuOpen(false)}
              >
                About
              </Link>

              <Link
                to="products"
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setMenuOpen(false)}
              >
                Products
              </Link>

              <Link
                to="gallery"
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setMenuOpen(false)}
              >
                Gallery
              </Link>

              <Link
                to="contact"
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setMenuOpen(false)}
              >
                Contact
              </Link>

              <div className="flex justify-center gap-6 pt-4">

                <FaFacebookF className="cursor-pointer text-green-700" />
                <FaInstagram className="cursor-pointer text-green-700" />
                <FaWhatsapp className="cursor-pointer text-green-700" />

              </div>

            </div>

          </div>

        )}

      </nav>
    </>
  );
}

export default Navbar;